import { EmbedView } from '../../../components/EmbedView';
import { SingleQueryResults } from '../../../components/QueryResults/SingleQueryResults';
import { useActiveWorkspace } from '../../../hooks/useActiveWorkspace';

/**
 * Historic Royalties "Paid Royalties" tab. Embeds MSR2's "Search paid
 * royalties" view, so members can find past royalties by title (and agents by
 * client), with MSR2's advanced filters (APP-2481).
 */
export const RoyaltiesPaidRoyalties = () => {
  const [, activeWorkspaceQuery] = useActiveWorkspace();

  return (
    <SingleQueryResults query={activeWorkspaceQuery}>
      {(workspace) => (
        <EmbedView
          embedType="royalties"
          loadingMessage="Loading your paid royalties, please stand by..."
          resourceId={workspace._id}
        />
      )}
    </SingleQueryResults>
  );
};
